<template>
  <div class="h-full ">
      <Head :title="__(title)" />
      <div class="flex flex-col flex-grow-1 flex-shrink-1 h-full">
          <div class="flex flex-col task__table overflow-y-auto h-full">
              <div class="inline-block min-w-full h-full py-4 align-middle md:px-3 lg:px-4">
                  <div class="table__view">
                      
                    <FullCalendar :options="calendarOptions" ref="calendar"/>
                  </div>
              </div>
          </div>

      </div>
      <appointment-details v-if="appointmentDetailsOpen"  view="table" :id="appointmentDetailsId"  :currentUserId="currentUserId" :types="types" :users="users" :isPopup="td_pop" @closeModal="closeDetails()" 
      @changes-saved="handleUpdateEvents" @appointment-deleted="handleUpdateEvents" />
  </div>
</template>


<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import BoardViewMenu from '@/Shared/BoardViewMenu'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import draggable from 'vuedraggable'
import AppointmentDetails from '@/Shared/Modals/AppointmentDetails'


export default {
  metaInfo: { title: 'Dashboard' },
    components: { Head, Icon, Link, draggable, Datepicker, BoardViewMenu, FullCalendar, AppointmentDetails},
  layout: Layout,
    props: {
        auth: Object,
        title: String,
        tasks: Object,
        filters: Object,
        workspace: Object,
        list_index: Object,
        board_lists: Object,
        events: Array,
        td_pop: false,
        currentUserId: {
            type: Number,
            required: true
        },
        types: {
            type: Array,
            default: () => []
        },
        users: {
            type: Array,
            default: () => []
        },
    },
    mounted() {
        console.log('Current User ID:', this.currentUserId);
    },
    remember: 'form',
    data() {
        return {
            calendarOptions: {
                plugins: [ dayGridPlugin, interactionPlugin ],
                initialView: 'dayGridMonth',    
                dateClick: this.handleDateClick,
                eventClick: this.handleDateClick2,
                events: this.events,
                locale: 'es',
            },
            appointmentDetailsOpen: false,
            appointmentDetailsId: '',
        }
    },
    methods: {
        handleDateClick: function(arg) {
            this.appointmentDetailsId = -1;
            //alert('date click! ' + arg.dateStr);
            this.appointmentDetailsOpen = true;
            this.td_pop = true;
        },
        handleDateClick2: function(arg) {
            this.appointmentDetailsId = -1;
            //alert('Click a evento ' + arg.event._def.publicId);
            console.log(arg);
            console.log(this.users);
            this.appointmentDetailsId = arg.event._def.publicId;
            this.appointmentDetailsOpen = true;
            this.td_pop = true;
        },
        appointmentDetailsPopup(arg){
            this.td_pop = true;
            this.appointmentDetailsOpen = true;
        },
        closeDetails(){
            this.appointmentDetailsOpen = false;
        },
        appointmentDetails(id){
            if(id){
                window.location.href = this.route('projects.table.with.task', {projectUid: this.project.id, taskUid: id});
            }
        },
        handleUpdateEvents(updatedAppointments) {
            this.calendarOptions.events = updatedAppointments;
            this.events= updatedAppointments;
            console.log("actualizado");
            console.log(updatedAppointments);
            closeDetails();
        },
    },
    computed: {
        isModalVisible() {
            return this.appointmentDetailsOpen;
        },
    },
}
</script>
